import { Injectable } from '@angular/core'; 
import { environment } from '../../../../environments/environment'; 
import { ApplicationInsights } from '@microsoft/applicationinsights-web'; 

@Injectable({ providedIn: 'root'}) 
export class MonitoringService { 

  // https://devblogs.microsoft.com/premier-developer/angular-how-to-add-application-insights-to-an-angular-spa/

  appInsights: ApplicationInsights;

  constructor() {
    if (environment.production)
    {
      let instrumentationKey = 'c16c20cc-6257-4d24-9f01-adac40631f45'; // by default use the test key
      if (location.hostname.includes('incase365')) {
        instrumentationKey = environment.appInsights.instrumentationKey;
      }
      console.log('Monitoring service instrumentation key', instrumentationKey);
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey,
          disableCookiesUsage: true, // (alias for cookieCfg.enabled, see https://github.com/microsoft/ApplicationInsights-JS#ICookieMgrConfig)
          // enableAutoRouteTracking: true, // option to log all route changes
        },
      });
      this.appInsights.loadAppInsights();
    }
    else 
      console.log('Monitoring service disabled for dev builds');
  }

  logPageView(name?: string, url?: string) { // option to call manually
    if (environment.production)    
      this.appInsights.trackPageView({
        name,
        uri: url,
      });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    if (environment.production)
      this.appInsights.trackEvent({ name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    if (environment.production)
      this.appInsights.trackMetric({ name, average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    if (environment.production)
      this.appInsights.trackException({ exception, severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    if (environment.production)
      this.appInsights.trackTrace({ message}, properties);
  }
}
